import { Point } from '../../index';

export function pointsDistance(point1: Point, point2: Point): number {
  return Math.pow(
    Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2),
    0.5
  );
}
